export default "__VITE_ASSET__BJasRLR7__"